export default {
	validations: {
		required: "值是必需的。",
		undefined: "值是必需的。",
		email: "值不是有效的电子邮件地址",
		minLength: "该字段的长度至少为 ${min} 个字符",
		maxLength: "允许的最大长度为 ${max}",
		minValue: "允许的最小值是 ${min}",
		maxValue: "允许的最大值是 ${max}",
		numeric: "值必须是数字",
		ipAddress: "该值不是有效的 IP 地址",
		sameAs: "该值必须等于 ${otherName} 值",
	}
}